export enum MeasuringPointLocation {
    Unspecified = 0,
    Floor = 1,
    Wall = 2,
    Ceiling = 3,
    HollowSpace = 4
}
